import React, { useEffect, useState } from "react";
import { Form, Offcanvas, Button } from "react-bootstrap";
import { storeCategoryServices } from "../../../../../APIServices/SitePilotManagement/StoreManagement/storeCategoryServices";

const AddCategory = ({ show, hide, title, getStoreCategoryList, getActiveStoreCategoryList }) => {
  const [name, setName] = useState("");
  const [loader, setLoader] = useState(false);

  const addNewStoreCategory = async () => {
    setLoader(true)
    let userData = {}
    userData.name = name
    let data = await storeCategoryServices.addNewStoreCategory(userData)
    if (data?.statusCode === 200) {
      getStoreCategoryList()
      getActiveStoreCategoryList()
      clearData();
    }
    setLoader(false)
  }
  
  const clearData = () => {
    setName("");
    setLoader(false)
    hide();
  }

  useEffect(() => {
    if (!show) {
      setName("");
      setLoader(false)
    }
  }, [show]);

  return (
    <Offcanvas show={show} onHide={hide} placement="end">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>

      <Offcanvas.Body>
        <Form>
          <Form.Group className="mb-2">
            <Form.Label>
              Name <span className="text-danger">*</span>
            </Form.Label>
            <Form.Control
              name="userName"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Enter Name"
            />
          </Form.Group>
          <div className="d-flex justify-content-end gap-2 mt-3">
            <Button onClick={clearData} style={{ fontSize: 12 }} variant="light" >
              Cancel
            </Button>
            <Button
              disabled={!name || loader}
              onClick={addNewStoreCategory}
              style={{ fontSize: 12 }}>
              {title}
            </Button>
          </div>
        </Form>
      </Offcanvas.Body>
    </Offcanvas>
  );
};

export default AddCategory;
